// The editor's layers bar (ref "layersBar") and canvas preview stick to the top of the screen while scrolling down.
// The bar's height changes as layers are added, so the preview's sticky offset follows it.
export default {
    data() {
        return {
            layersBarHeight: 0
        }
    },
    mounted() {
        this.observeLayersBar()
    },
    updated() {
        this.observeLayersBar()
    },
    beforeDestroy() {
        if (this.layersBarObserver) {
            this.layersBarObserver.disconnect()
        }
    },
    methods: {
        observeLayersBar() {
            const bar = this.$refs.layersBar
            if (bar === this.observedLayersBar || typeof ResizeObserver === 'undefined') {
                return
            }
            if (!this.layersBarObserver) {
                this.layersBarObserver = new ResizeObserver(() => {
                    this.layersBarHeight = this.observedLayersBar ? this.observedLayersBar.offsetHeight : 0
                })
            }
            this.layersBarObserver.disconnect()
            this.observedLayersBar = bar
            if (bar) {
                this.layersBarObserver.observe(bar)
            } else {
                this.layersBarHeight = 0
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/stickyLayers.js